import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, withModifiers as _withModifiers, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, Transition as _Transition } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "navBarMobile"
}
const _hoisted_2 = { class: "navBarMobile_drawer" }
const _hoisted_3 = { class: "navBarMobile_header" }
const _hoisted_4 = { class: "navBarMobile_profile" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "navBarMobile_profileInfo" }
const _hoisted_7 = { class: "navBarMobile_name" }
const _hoisted_8 = {
  key: 0,
  class: "navBarMobile_profileSub"
}
const _hoisted_9 = { class: "navBarMobile_nav" }
const _hoisted_10 = { class: "navBarMobile_system" }
const _hoisted_11 = { class: "navBarMobile_systemTitle" }
const _hoisted_12 = { class: "navBarMobile_settingsTriggerText" }
const _hoisted_13 = { class: "navBarMobile_itemText" }
const _hoisted_14 = {
  key: 0,
  class: "navBarMobile_settingsSub"
}

import { ref, computed, watch } from 'vue'
import { useRoute } from 'vue-router'

import { useStore } from '@web/store'

import PAGE_NAME from '@web/consts/PAGE_NAME'
import PointsLabel from '@web/platform.v3/components/pointsLabel.vue'
import LangSelector from '@web/platform.v3/components/menu/langSelector.vue'
import { specialProjectId } from '@web/common/ExternalConfig/getters'
import locale from '@web/common/locale'


export default /*@__PURE__*/_defineComponent({
  ...{
  name: 'NavBarMobile'
},
  __name: 'navBarMobile',
  props: {
  modelValue: {
    type: Boolean,
    default: false
  }
},
  emits: ["update:modelValue"],
  setup(__props, { emit: __emit }) {

const POINTS_ROUTES = [PAGE_NAME.POINTS, PAGE_NAME.POINTS_HISTORY]
const PROFILE_ROUTES = [PAGE_NAME.EDIT_PROFILE]
const SETTINGS_ROUTES = [
  PAGE_NAME.SETTINGS_REMINDERS_TRAINING,
  PAGE_NAME.SETTINGS_SOCIAL_NETWORKS,
  PAGE_NAME.SETTINGS_NOTIFICATIONS,
  PAGE_NAME.SETTINGS_USER_PAYMENT_METHODS
]





const emit = __emit

const route = useRoute()
const store = useStore()
const projectId = computed(() => specialProjectId())
const user = computed(() => store.getters['user/user'])
const username = computed(() => store.getters['user/username'])
const logo = computed(() => store.getters['assets/logo'])
const userScoreAmount = computed(() => store.getters['userScore/amount'])
const projectName = computed(() => store.getters['assets/projectTitle'])
const isActivePoints = computed(() => POINTS_ROUTES.includes(route.name as string))
const isShowInstallments = computed(() => store.getters['installments/isLoaded'] && !store.getters['installments/isEmpty'])
const canChangeLang = computed(() => locale.SUPPORTED_LANGUAGE.length > 1)

const profileExpanded = ref(false)
const settingsExpanded = ref(false)

watch(
  () => route.name,
  (name) => {
    profileExpanded.value = PROFILE_ROUTES.includes(name as string) || POINTS_ROUTES.includes(name as string)
    settingsExpanded.value = SETTINGS_ROUTES.includes(name as string)
  },
  { immediate: true }
)

function close () {
  emit('update:modelValue', false)
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_Transition, { name: "navBarMobile-fade" }, {
    default: _withCtx(() => [
      (__props.modelValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_router_link, {
                  to: { name: _unref(PAGE_NAME).HOME },
                  class: "navBarMobile_logo",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: _normalizeClass(['navBarMobile_logoImg', `-${projectId.value}`]),
                      style: _normalizeStyle({
                backgroundImage: `url(${logo.value.src})`,
                maskImage: `url(${logo.value.src})`
              })
                    }, null, 6)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("img", {
                  src: user.value.avatar,
                  alt: "",
                  class: "navBarMobile_avatar"
                }, null, 8, _hoisted_5),
                _createElementVNode("div", {
                  class: "navBarMobile_profileWrapper",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (profileExpanded.value = !profileExpanded.value), ["stop"]))
                }, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("span", _hoisted_7, _toDisplayString(username.value), 1),
                    _createVNode(PointsLabel, {
                      points: userScoreAmount.value,
                      "only-text": "",
                      class: "navBarMobile_points"
                    }, null, 8, ["points"])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["navBarMobile_chevron", { '-open': profileExpanded.value }])
                  }, [...(_cache[2] || (_cache[2] = [
                    _createElementVNode("svg", {
                      width: "20",
                      height: "20",
                      viewBox: "0 0 20 20",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg"
                    }, [
                      _createElementVNode("g", { "clip-path": "url(#clip0_21390_13964)" }, [
                        _createElementVNode("g", { "clip-path": "url(#clip1_21390_13964)" }, [
                          _createElementVNode("path", {
                            d: "M3.5 7L10 13L16.5 7",
                            stroke: "#697076",
                            "stroke-width": "2",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round"
                          })
                        ])
                      ]),
                      _createElementVNode("defs", null, [
                        _createElementVNode("clipPath", { id: "clip0_21390_13964" }, [
                          _createElementVNode("rect", {
                            width: "20",
                            height: "20",
                            fill: "white"
                          })
                        ]),
                        _createElementVNode("clipPath", { id: "clip1_21390_13964" }, [
                          _createElementVNode("rect", {
                            width: "20",
                            height: "20",
                            fill: "white"
                          })
                        ])
                      ])
                    ], -1)
                  ]))], 2)
                ])
              ]),
              (profileExpanded.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createVNode(_component_router_link, {
                      to: { name: _unref(PAGE_NAME).EDIT_PROFILE },
                      class: "navBarMobile_item",
                      "exact-active-class": "-active",
                      onClick: close
                    }, {
                      default: _withCtx(() => [
                        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                          _createElementVNode("i", { class: "navBarMobile_icon -userEdit" })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('editProfile')), 1)
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createVNode(_component_router_link, {
                      to: { name: _unref(PAGE_NAME).POINTS },
                      class: _normalizeClass(["navBarMobile_item", { '-active': isActivePoints.value }]),
                      onClick: close
                    }, {
                      default: _withCtx(() => [
                        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                          _createElementVNode("i", { class: "navBarMobile_icon -points" })
                        ], -1)),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('Points')) + " " + _toDisplayString(projectName.value), 1)
                      ]),
                      _: 1
                    }, 8, ["to", "class"])
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("nav", _hoisted_9, [
                _createVNode(_component_router_link, {
                  to: { name: _unref(PAGE_NAME).HOME },
                  class: "navBarMobile_item",
                  "exact-active-class": "-active",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _cache[5] || (_cache[5] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                      _createElementVNode("i", { class: "navBarMobile_icon -home" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('crumb.general')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: { name: _unref(PAGE_NAME).SUPPORT },
                  class: "navBarMobile_item",
                  "exact-active-class": "-active",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _cache[6] || (_cache[6] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                      _createElementVNode("i", { class: "navBarMobile_icon -support" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('supportCenter')), 1)
                  ]),
                  _: 1
                }, 8, ["to"]),
                _createVNode(_component_router_link, {
                  to: { name: _unref(PAGE_NAME).SUBSCRIPTIONS },
                  class: "navBarMobile_item",
                  "exact-active-class": "-active",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                      _createElementVNode("i", { class: "navBarMobile_icon -subscriptions" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('Subscriptions')), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "navBarMobile_divider" }, null, -1)),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('system')), 1),
                _createElementVNode("div", {
                  class: _normalizeClass(["navBarMobile_settingsTrigger", { '-open': settingsExpanded.value }]),
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (settingsExpanded.value = !settingsExpanded.value))
                }, [
                  _cache[9] || (_cache[9] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                    _createElementVNode("i", { class: "navBarMobile_icon -settings" })
                  ], -1)),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('Settings')), 1),
                    _createElementVNode("div", {
                      class: _normalizeClass(["navBarMobile_chevron", { '-open': settingsExpanded.value, '-active': settingsExpanded.value }])
                    }, [...(_cache[8] || (_cache[8] = [
                      _createElementVNode("svg", {
                        width: "20",
                        height: "20",
                        viewBox: "0 0 20 20",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg"
                      }, [
                        _createElementVNode("g", { "clip-path": "url(#clip0_21390_13964)" }, [
                          _createElementVNode("g", { "clip-path": "url(#clip1_21390_13964)" }, [
                            _createElementVNode("path", {
                              d: "M3.5 7L10 13L16.5 7",
                              stroke: "#697076",
                              "stroke-width": "2",
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round"
                            })
                          ])
                        ]),
                        _createElementVNode("defs", null, [
                          _createElementVNode("clipPath", { id: "clip0_21390_13964" }, [
                            _createElementVNode("rect", {
                              width: "20",
                              height: "20",
                              fill: "white"
                            })
                          ]),
                          _createElementVNode("clipPath", { id: "clip1_21390_13964" }, [
                            _createElementVNode("rect", {
                              width: "20",
                              height: "20",
                              fill: "white"
                            })
                          ])
                        ])
                      ], -1)
                    ]))], 2)
                  ])
                ], 2),
                _createVNode(_Transition, { name: "navBarMobile-slide" }, {
                  default: _withCtx(() => [
                    (settingsExpanded.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                          _createVNode(_component_router_link, {
                            to: { name: _unref(PAGE_NAME).SETTINGS_REMINDERS_TRAINING },
                            class: "navBarMobile_settingsItem",
                            "exact-active-class": "-active"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('reminderTraining')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: { name: _unref(PAGE_NAME).SETTINGS_SOCIAL_NETWORKS },
                            class: "navBarMobile_settingsItem",
                            "exact-active-class": "-active"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('addLoginMethods')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: { name: _unref(PAGE_NAME).SETTINGS_NOTIFICATIONS },
                            class: "navBarMobile_settingsItem",
                            "exact-active-class": "-active"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('notificationSettings')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _createVNode(_component_router_link, {
                            to: { name: _unref(PAGE_NAME).SETTINGS_USER_PAYMENT_METHODS },
                            class: "navBarMobile_settingsItem",
                            "exact-active-class": "-active"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('userPaymentMethods.title')), 1)
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          (isShowInstallments.value)
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 0,
                                to: { name: _unref(PAGE_NAME).INSTALLMENTS },
                                class: "navBarMobile_settingsItem",
                                "exact-active-class": "-active"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.$t('installments.shortTitle')), 1)
                                ]),
                                _: 1
                              }, 8, ["to"]))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                (canChangeLang.value)
                  ? (_openBlock(), _createBlock(LangSelector, {
                      key: 0,
                      fromMenu: "navBarMobile"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_router_link, {
                  to: { name: _unref(PAGE_NAME).LOGOUT },
                  class: "navBarMobile_item",
                  onClick: close
                }, {
                  default: _withCtx(() => [
                    _cache[10] || (_cache[10] = _createElementVNode("div", { class: "navBarMobile_iconWrapper" }, [
                      _createElementVNode("i", { class: "navBarMobile_icon -logout" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('exit')), 1)
                  ]),
                  _: 1
                }, 8, ["to"])
              ])
            ]),
            _createElementVNode("button", {
              type: "button",
              class: "navBarMobile_close",
              "aria-label": "Close",
              onClick: close
            }, [...(_cache[12] || (_cache[12] = [
              _createElementVNode("div", { class: "navBarMobile_close-icon" }, [
                _createElementVNode("svg", {
                  width: "20",
                  height: "20",
                  viewBox: "0 0 20 20",
                  fill: "none",
                  xmlns: "http://www.w3.org/2000/svg"
                }, [
                  _createElementVNode("g", { "clip-path": "url(#clip0_21390_14226)" }, [
                    _createElementVNode("path", {
                      d: "M4 4L16 16M16 4L4 16",
                      stroke: "white",
                      "stroke-width": "1.5",
                      "stroke-linecap": "round"
                    })
                  ]),
                  _createElementVNode("defs", null, [
                    _createElementVNode("clipPath", { id: "clip0_21390_14226" }, [
                      _createElementVNode("rect", {
                        width: "20",
                        height: "20",
                        fill: "white"
                      })
                    ])
                  ])
                ])
              ], -1)
            ]))]),
            _createElementVNode("div", {
              class: "navBarMobile_overlay",
              "aria-hidden": "true",
              onClick: close
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})